export default {
    name: 'app-not-found',
}